import React, { Component,Fragment } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBTableBody,MDBTable, MDBTableHead, MDBAlert, MDBSelect , MDBInput, MDBIcon ,MDBDataTable, MDBRow, MDBCol  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import domtoimage from 'dom-to-image';
import { api, URL } from '../../api';

import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class ModalAddstudentforadmin extends Component {
   
constructor(props) {
  super(props);
  this.state = {
  modal: false,

  Curriculumopen_Full_Name_TH:'',
  Curriculumopen_Full_Name_EN:'',
  Curriculumopen_CH:'',

  Curriculumopen_ID:'',
  Studentcb_ID:'',
  Citizen:'',

  studentlist:[],
  Numlist:[],

  Studentcb:'',//หมู่เรียน
  term:'',//เทอม
  Course_ID:'',//รหัสวิชา

  Curriculumopen_ID:'',//idหลักสูตร

  studenttabian:[],//นักศึกษาที่ลงทะเบียน
  
}

this.handleSubmit = this.handleSubmit.bind(this);
this.getregisterCurriculum = this.getregisterCurriculum.bind(this);
this.getsearch = this.getsearch.bind(this);
this.onTextChange = this.onTextChange.bind(this);
this.getstudentfromtabian = this.getstudentfromtabian.bind(this);

}


      toggle = () => {
          this.setState({
          modal: !this.state.modal
          });
        //  this.setState({ Citizen:this.props.Citizen})
        this.setState({ Course_ID:this.props.Course_ID})
        this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID})
          this.getregisterCurriculum();
      }

      getregisterCurriculum() {
          setTimeout(() => {
             //ภายใน
         //    api.get('index/getCurriculumstudentlist/'+this.props.Curriculumopen_ID)
             api.get('index/getCurriculumstudentlisttoarit/'+this.props.Curriculumopen_ID)
             .then(res => {
             //  console.log(res.data);
            //   const Numlist = res.data.filter( ({ Studentcb_Citizen_ID }) => Studentcb_Citizen_ID === this.props.Citizen );
             //  this.setState({ bankname: res.data, loading: false })
               this.setState({ Numlist : res.data})
             }) 
           }, 0);
      }


      handleSubmit() {
          // alert('A name was submitted: ' + this.state.value);
         setTimeout(() => {  
     for (let index = 0; index < this.state.studenttabian.length; index++) {     
            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
            datafrm.append("Curriculumopen_ID", this.state.Curriculumopen_ID);
            datafrm.append("Studentcb_ID", this.state.studenttabian[index].Studentcb_ID);
            datafrm.append("Studentcb_Citizen_ID", this.state.studenttabian[index].Studentcb_Citizen_ID);
            
            api.post("index/AddregisterCurriculum/",datafrm,{
                  headers: {
                      'content-type': 'multipart/form-data'
                  }
             })
      
                .then(res => {
                  //    console.log(res);
                      if (this.state.studenttabian.length === index+1) {
                      //  alert("บันทึกสำเร็จ")
                                Swal.fire({
                                    title: 'ลงทะเบียนสำเร็จ',
                                    icon: 'success',
                                  // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                  // cancelButtonText: 'No, keep it'
                                  }).then((result) => {
                                  this.toggle()
                                  })
                              }
                      })

                     // this.getregisterCurriculum();
                    // this.toggle()
                    //  this.props.getclassroom()

       }//ปิดloop
              }, 1000);
    
      //window.location.href = '/Curriculum'
      //this.props.updateat();
      //this.getExpert()
       
        }


         getsearch(value) {
          setTimeout(() => {
           console.log(value)
          //  const Course = this.state.Course.filter( ({ Curriculumopen_TEAM }) => Curriculumopen_TEAM === value );
            this.setState({ term : value});
           }, 0);
        }

         onTextChange = (e) => {
                this.setState({ [e.target.name]: e.target.value })
              }




      componentDidMount() {

          //const { id_send } = this.props.id_send
          console.log( this.props.Curriculumopen_Full_Name_TH);
       
          }


             
         getstudentfromtabian() {
                    setTimeout(() => {
                       //ภายใน
                       api.get('index/getstudenttabian/'+this.state.term+'/'+this.state.Studentcb+'/'+this.state.Course_ID)
                       .then(res => {
                         console.log(res);
                       //  this.setState({ bankname: res.data, loading: false })
                         this.setState({ studenttabian: res.data})
                       }) 
                     }, 0);
                }


    


render() {
 // console.log(this.state.Numlist.length)

      const { Option } = Select;

 const datast = {
  columns: [
    {
      label: '#',
      field: 'list',
      sort: 'list',
      width: 150
    },
    {
        label: 'username',
        field: 'Studentcb_Citizen_ID',
        sort: 'Studentcb_Citizen_ID	',
        width: 150
      },
      {
        label: 'รหัสนักศึกษา',
        field: 'Studentcb_DB',
        sort: 'Studentcb_DB',
        width: 150
      },
      {
        label: 'รหัสวิชา',
        field: 'pname',
        sort: 'pname',
        width: 150
      },
    {
      label: 'ชื่อ',
      field: 'Studentcb_NAME',
      sort: 'Studentcb_NAME',
      width: 150
    },
    {
      label: 'นามสกุล',
      field: 'Studentcb_LASTNAME',
      sort: 'Studentcb_LASTNAME',
      width: 270
    },
  
    {
      label: 'เทอม',
      field: 'Studentcb_EMAIL',
      sort: 'Studentcb_EMAIL',
      width: 100
    },
   


  ],

  rows: [...this.state.studenttabian.map((data, i) => (
    {
       list: <>{i+1}</>,
       Studentcb_Citizen_ID	: <>{data.Studentcb_Citizen_ID}</>,
       Studentcb_DB: <>{data.ID_NO}</>,
       pname: <>{data.SJCODE}</>,
       Studentcb_NAME: <>{data.FULLNAME}{data.Studentcb_NAME}</>,
       Studentcb_LASTNAME: <>{data.Studentcb_LASTNAME}</>,
       Studentcb_EMAIL: <>{data.TERM}</>,
     

      random: <h5 searchvalue={data.Studentcb_Citizen_ID} >tourist <span className="badge badge-danger">narrow</span></h5>,
      
    }
   ))]
  

  };

      const persons = <MDBDataTable
      // searching ={true} 
      searchLabel="ค้นหาชื่อ"
      striped
      bordered
      small 
      entries={20}
      // entriesOptions={["10", "20"]}
      order={["age", "desc"]}
      data={datast}
      entriesLabel="จำนวนที่แสดง "
      infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
      paginationLabel={["ย้อนกลับ", "ถัดไป"]}
      responsive 
      sortRows={['random']}
      />


  return (
      <>
         
              <MDBBtn onClick={this.toggle} color="success" size='sm' >เพิ่มนักศึกษา</MDBBtn>

              <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">



                  


              <MDBModalHeader toggle={this.toggle}><MDBIcon icon="list-alt" /> รายชื่อนักศึกษา </MDBModalHeader>
             
                  <MDBModalBody>
                      <h5>หลักสูตร {this.props.Curriculumopen_Full_Name_TH} {this.props.Curriculumopen_ID}</h5>  
                      {/* {this.props.Citizen} */} <MDBRow>
                       <MDBCol sm="4">
            <label htmlFor="example2"><MDBIcon icon="search" /> เลือกเทอม </label><br/>
            <Select
                    showSearch
                    style={{ width: 300 }}
                    placeholder="เลือกเทอม"
                    optionFilterProp="children"
                    onChange={this.getsearch}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="3/69">3/2569</Option>
                    <Option value="2/69">2/2569</Option>
                    <Option value="1/69">1/2569</Option>
                    <Option value="3/68">3/2568</Option>
                    <Option value="2/68">2/2568</Option>
                    <Option value="1/68">1/2568</Option>
                    
                   
                   {/* {this.state.Coursesearch.map((Course,index )  => 
                   <option value={Course.Curriculumopen_ID}>{Course.Curriculumopen_Full_Name_TH}</option>
                   )} */}
            </Select>
            </MDBCol>

            <MDBCol sm="4">
               <div className="form-group">
                   <label htmlFor="example2">หมู่เรียน</label>
                   <Input placeholder="หมู่เรียน" value={this.state.Studentcb} name="Studentcb" onChange={this.onTextChange} required  />                                
               </div>
                <MDBBtn onClick={this.getstudentfromtabian} color="primary" size='sm' >ค้นหา</MDBBtn>   
            </MDBCol> 

           

            
                   </MDBRow>
                      

                     


                        {persons}
                              
                      <p className="text-center"><MDBBtn color="secondary" onClick={this.handleSubmit} >ลงทะเบียนในหลักสูตร</MDBBtn></p>
                       
                  </MDBModalBody>
                  <MDBModalFooter>
                  <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                  {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                  </MDBModalFooter>
              </MDBModal>
         
      </>
  )
}
}
